// 该文件为自动生成，请不要直接修改该文件(直接修改该文件,送翻后修改会失效)
/* eslint-disable */
export default {
  "3310488360": "ドキュメントを小プログラムに入れる",
  "4018638528": "WeChatでQRコードをスキャンして体験する",
  "d835ee6e91": "ファイルは保存されました<a target=\"_blank\" href=\"//plus.wps.cn/view/media/p/{0}\" style=\"margin-left:10px;color:#417ff9\">表示</a>",
  "a83b7c3d4d": "ファイルの移動に成功しました",
  "ded158d9dc": "ファイルの共有が停止されました",
  "11377326ac": "ログインしてからアクセスを試してください",
  "321495498a": "このファイルは現在オンラインプレ表示がサポートされていません。ダウンロードして表示してください",
  "6728034eac": "この企業のメンバーではありません",
  "c1c0c3ef49": "サーバーエラーが発生しました。しばらくしてから再試行してください",
  "94bd113e7c": "ファイルが破損しています。ダウンロードして表示してください",
  "e242d9844d": "ファイル形式はオンライン再生に対応していません。ダウンロードして表示してください",
  "7703961444": "変換タスクがタイムアウトしました",
  "85d6dfb01c": "音声・動画のオンライン再生権利が使用済みです。ダウンロードして表示してください",
  "aa35fa807c": "この企業の音声・動画のオンライン再生は無効になっています。カスタマーサービスにお問い合わせください",
  "4c5c817619": "作者がこのファイルを削除しました",
  "b8b1ab19a3": "読み込みがタイムアウトしました。しばらくしてから再試行してください",
  "69570a01ee": "作者がこのファイルの共有を停止しました",
  "ce6559062c": "ファイルの変換中...#{percent}%",
  "05bd98be76": "共有リンクが閉じられました",
  "c48dea50b2": "操作権限が不足しています",
  "780dc2da0a": "ファイルには禁止されたコンテンツが含まれている可能性があり、アクセスが停止されました",
  "bdeb76266c": "このファイルのダウンロード権限がありません",
  "f99e7e8772": "この形式のファイルはダウンロードに対応していません",
  "c99e7e8772": "ファイルのプレビュー変換中です。しばらくしてから再試行してください",
  "f996285100": "再生",
  "ed208c3846": "再生をやり直す",
  "c96a46727b": "一時停止",
  "021ad16252": "ミュート",
  "c5042be9e1": "ミュート解除",
  "aaee2e3006": "フルスクリーン",
  "c1e237fdf1": "フルスクリーンを終了",
  "f1e2762445": "WPS",
  "2fd888fd9a": "フィードバックでアクセスを回復する",
  "800bee819a": "ファイルの共有が停止されました",
  "bc599ee5cd": "フィードバックで共有を回復する",
  "8fe1ecec60": "ローカルにダウンロードして表示する",
  "39a641bdc3": "申し立てが提出されました",
  "aed856a076": "審査は48時間以内に完了する予定です。お待ちください",
  "025e60d871": "WPSに入る",
  "e385ada474": "ファイルの解除に失敗しました",
  "21805326f1": "ファイルには禁止されたコンテンツが含まれている可能性があります。再度申し立てることができます",
  "a20c3cecc5": "再度申し立てる",
  "06bff8a305": "内容は50文字を超えることはできません",
  "188c4f96ac": "申し立ての理由を入力してください",
  "fba51b188e": "申し立ての理由を詳細に説明してください",
  "919c36e310": "ビデオ",
  "46680e2228": "ファイルの変換中...",
  "3d86d5e41b": "ファイルの変換中...{0}%",
  "6fb2ee95a6": "ファイルを取得中...",
  "447ee65591": "金山ドキュメント",
  "6c4746f45e": "金山ドキュメント",
  "c8ccb36124": "閉じる",
  "060897215f": "ドキュメントをアプリに保存",
  "d488af2c8e": "WeChatでスキャンして体験",
  "92861a3b7f": "更新日：",
  "122ce7bbe9": "共有",
  "8742930fad": "ログイン",
  "265b2730bd": "共有",
  "40ad48e2e6": "携帯に送信",
  "de36f56297": "名前を付けて保存",
  "88a5eec7a5": "ダウンロード",
  "e42de3af08": "ホームに戻る",
  "bb898f8c35": "ファイルを報告",
  "ff71e4f8a2": "ローカルアプリで開く",
  "cd8cf2f471": "他の企業の音声およびビデオファイルはオンライン再生できません。ダウンロードして表示してください。",
  "9cae53c65a": "サーバーエラーが発生しました。後でもう一度お試しください。",
  "a670f3c26a": "企業の管理者によって現在の操作が禁止されています。",
  "4cbad45623": "ダウンロード",
  "9928443135": "共有",
  "e4f4b9a34d": "名前を付けて保存",
  "b33f514a94": "ヘルプとフィードバック",
  "bb4e26ff65": "ファイルを報告",
  "b8ed5c2de7": "保存して開く",
  "e453958fe2": "サーバーエラーが発生しました。後でもう一度お試しください。",
  "79be6d4e4c": "ビデオ",
  "0354b7ed16": "ファイルの場所：",
  "137c5f6d85": "更新日：",
  "d1674c594a": "共有",
  "6a2244a811": "ログイン",
  "4ec31fbe91": "WPSで開く",
  "b30f2ea44b": "金山ドキュメントのホームページ",
  "3314fc385b": "ファイル",
  "0686b09373": "{0}つ星",
  "18eb6b5d58": "キャンセル",
  "8a2a385103": "変更が成功しました",
  "4710fe77f2": "変更に失敗しました",
  "cc0040f6e7": "ドキュメントの所有者のみが名前を変更できます",
  "fb603598cc": "スター付きドキュメントに設定されました。すばやくアクセスできます",
  "b6e981a032": "表示",
  "bfa2986eb3": "スター付きドキュメントをキャンセル",
  "cb5f342bef": "{0}つ星付きドキュメントの設定に失敗しました",
  "0482a30b20": "設定",
  "d1a3a7b120": "金山ドキュメント",
  "2314ce6081": "作成者が指定した人にアクセスを設定しています。お問い合わせください",
  "241c63f81a": "\n          または許可されたアカウントでログインしてください\n        ",
  "b573db113b": "作成者が企業メンバーのアクセスを設定しています。お問い合わせください",
  "12069886e3": "現在のログインアカウント：{0}",
  "ced44fd785": "申請は30分以内に処理されます。しばらくしてから更新して確認してください",
  "a8c1a910b2": "アクセスの復元を申請する",
  "d8ffb18522": "ダウンロード",
  "6e4e2132b7": "ログイン",
  "71737deac3": "金山ドキュメントに入る",
  "65680083e0": "すぐに認証する",
  "dbc00698ae": "アクセス権限がありません",
  "0c01094048": "ファイルの共有が停止されました",
  "8af9862a91": "ファイルは削除されました",
  "4d74f721f5": "ファイルが存在しません",
  "1a9e17476b": "ファイルのアクセスが停止されました",
  "6667a5fc14": "アクセスの復元が申請されました",
  "fdb37ade7f": "金山オフィス・一緒に効率的に働く",
  "dc8e5b3b97": "サーバーエラーが発生しました。後でもう一度お試しください。",
  "11373c971b": "カスタマーサービスに連絡する",
  "1b310928e3": "購入後、企業認証を通過する必要があります",
  "d4c9ed35b7": "プレビュー変換中",
  "5007152f7d": "アップグレードパッケージを申請する",
  "7ae4470de8": "アップグレードパッケージ",
  "5a50e52115": "{0}を購入すると、【音声およびビデオ再生時間】の特典を無制限に使用できます。",
  "cdc5268c10": "アップグレードパッケージで音声およびビデオをオンラインでプレビューできます。ダウンロード待ち時間が省けます。",
  "0e76e21514": "フィードバックの理由",
  "c28bff886a": "（5〜50文字を入力してください）",
  "bfa366d4df": "フィードバックの理由を詳細に説明してください。フィードバックの進捗を早めることができます",
  "8c30b9472d": "提出する",
  "309ec43078": "フィードバック",
  "6479ccd94a": "フィードバックの理由",
  "fc4e48a17a": "（5-50文字で入力してください）",
  "58f69ca425": "フィードバックの理由を詳細に説明してください。フィードバックの進捗を早めることができます",
  "7b5fb662cc": "送信",
  "2152682d5d": "このファイルは現在オンラインプレ表示がサポートされていません。ダウンロードして表示してください",
  "887322b897": "サーバーエラーが発生しました。しばらくしてから再試行してください。",
  "27ef615a27": "<p>作者に連絡してください</p><p>現在のログインアカウント {0}</p>",
  "5306bedfb4": "管理者に連絡して、ビジネスプランをアップグレードし、音声およびビデオのオンライン再生権を開通してください",
  "39dba15903": "現在の企業プランには音声およびビデオのオンライン再生権が含まれていません。購入については、お問い合わせください：17607563040",
  "c6110c9a54": "この企業以外の音声およびビデオファイルはオンラインで再生できません。ダウンロードしてご覧ください。",
  "4db4c3dc63": "管理者に連絡して、企業認証を完了させると、音声およびビデオのオンライン再生権限を利用できます。",
  "a2368c2d06": "企業が認証されていません。認証が通れば、音声およびビデオのオンライン再生権限を利用できます。",
  "8bd57619ed": "このファイルは現在オンラインプレ表示がサポートされていません。ダウンロードして表示してください",
  "a0f065de59": "サーバーエラーが発生しました。しばらくしてから再試行してください。",
  "6c9f11f229": "<p>作者に連絡してください</p><p>現在のログインアカウント {0}</p>",
  "aaad91aec8": "管理者に連絡して企業プランをアップグレードし、音声およびビデオのオンライン再生権を開通してください",
  "f1bd446446": "現在の企業プランには音声およびビデオのオンライン再生権が含まれていません。購入についてはお問い合わせください：17607563040",
  "22f2a07b81": "他の企業の音声およびビデオファイルはオンライン再生に対応していません。ダウンロードしてご確認ください",
  "1cd5c90386": "管理者に連絡して企業認証を完了し、音声およびビデオのオンライン再生権を利用できるようにしてください",
  "a04123abbc": "企業が認証されていません。企業認証を行ってください（無料）<br/>認証が完了すれば再生できます",
  "fdd678fd78": "カスタマーサービスに連絡してください",
  "471041043d": "「金山文書」カスタマーサービスQQ番号",
  "89a75c2d8d": "グループ番号をコピー",
  "1894fcb0c1": "「金山文書」フィードバック交流WeChatグループ",
  "081814f2bd": "画像を保存し、QRコードをスキャンしてグループに参加",
  "26b115245d": "コピーが成功しました",
  "f96075a6c8": "現在の共有リンクは無効です",
  "d22b2a0380": "問題がフィードバックされました",
  "90446028cc": "問題をフィードバックする",
  "4ca22157a0": "申し立てが正常に送信されました",
  "1d3c1de9d7": "申し立ての提出に失敗しました",
  "4e0e975d62": "ダウンロードはサポートされていません",
  "04edf8028f": "ファイル名が存在しません",
  "1ee5f66661": "送信",
  "c2c0c5ef78": "ファイルが異常です。再度アップロードする前に確認してください。"
}
